import { useProductTileClickImpressionContext } from "@faire/retailer-visitor-shared/hooks/ProductTileImpression/useProductTileClickImpressionContext";
import { useEffectEvent } from "@faire/web/ui/hooks/useEffectEvent";
import { trackProductTileProductTileOnTouchStartActionCategoryOther } from "@faire/web-api--source/events/productTile/actionCategoryOther/productTileOnTouchStart";

export const useOnTouchStartEvent = (token: string | undefined) => {
  const productTileContext = useProductTileClickImpressionContext();

  return useEffectEvent(() => {
    trackProductTileProductTileOnTouchStartActionCategoryOther(
      token ?? "",
      productTileContext.requestId ?? ""
    );
  });
};
